export default [
  {
    path: "/plantillas",
    component: () => import("@/views/plantillas/Listar.vue"),
  },
];
